import { ReactElement, useEffect, useState } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

import { Spacing } from '../../style'
import { Banner } from '../feedback'

import HelpIcon from './icon'
import HelpPointer from './pointer'

const styles = StyleSheet.create({
  container: {},
  content: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  topLeft: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  helpTop: {
    flex: undefined,
  },
  hidden: {
    opacity: 0,
    height: 0,
  },
  help: {
    marginLeft: Spacing.XXS,
    marginTop: -2,
  },
  helpPointer: {
    marginLeft: Spacing.XXS - 3,
  },
  helpBanner: {
    marginBottom: Spacing.S,
  },
})

export interface Props extends ViewProps {
  message?: string | ReactElement
  right?: ReactElement
  icon?: ReactElement | false
  show?: boolean
  onShowChange?: (show: boolean) => void
  pointerStyle?: StyleProp<ViewStyle>
}

const HelpView = (props: Props) => {
  const { message, right, icon, show, onShowChange, pointerStyle, style, children, ...otherProps } = props
  const [showHelp, setShowHelp] = useState(!!show)

  useEffect(() => {
    setShowHelp(!!show)
  }, [show])

  function update(show: boolean) {
    setShowHelp(show)
    onShowChange?.(show)
  }

  function renderIcon() {
    if (icon === false) return null
    return icon || <HelpIcon style={styles.help} onPress={() => update(!showHelp)} />
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.content}>
        {children}
        {renderIcon()}
        {right}
      </View>
      {showHelp && (
        <View>
          <View style={[styles.topLeft, styles.helpTop]}>
            {!!children && <View style={styles.hidden}>{children}</View>}
            <HelpPointer style={[styles.helpPointer, pointerStyle]} />
          </View>
          <Banner message={message} status="help" closeable onClose={() => update(false)} style={styles.helpBanner} />
        </View>
      )}
    </View>
  )
}

export default HelpView
